import { render } from "./FlutesView.vue?vue&type=template&id=a211b6e8&scoped=true&ts=true"
import script from "./FlutesView.vue?vue&type=script&lang=ts"
export * from "./FlutesView.vue?vue&type=script&lang=ts"

import "./FlutesView.vue?vue&type=style&index=0&id=a211b6e8&scoped=true&lang=css"
import "@/assets/css/style.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a211b6e8"]])

export default __exports__